var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHabitsSweets = function SvgHabitsSweets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc49c",
    d: "M10.343 38.5a2.498 2.498 0 0 1-2.426-1.894L4.641 23.5H35.36l-3.276 13.106a2.496 2.496 0 0 1-2.426 1.894z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a16a4a",
    d: "m34.719 24-3.121 12.485A1.997 1.997 0 0 1 29.658 38H10.342a1.997 1.997 0 0 1-1.94-1.515L5.281 24zM36 23H4l3.432 13.728A3 3 0 0 0 10.342 39h19.315a2.999 2.999 0 0 0 2.91-2.272z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a16a4a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M23.5 34.5v-10m5 10 1-10m-13 10v-10m-5 10-1-10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M15 28.5c-8.075 0-13.5-3.014-13.5-7.5 0-3.72 3.432-6.5 6.5-6.5h.5V14c0-3.611 3.27-5.5 6.5-5.5h.41l.08-.402c.353-1.765 1.158-2.419 2.01-3.112.906-.737 1.842-1.498 1.982-3.461C22.121 1.782 26.5 4.046 26.5 8v.5h.5c7.021 0 11.5 6.219 11.5 10.5 0 4.299-3.639 7.18-5.121 8.175C32.888 25.438 30.93 23.5 28 23.5c-1.918 0-3.256.983-4.671 2.025C21.433 26.919 19.284 28.5 15 28.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M19.922 2.088C22.401 2.523 26 4.575 26 8v1h1c6.613 0 11 6.019 11 10 0 3.627-2.779 6.207-4.378 7.392C32.851 24.686 30.918 23 28 23c-2.082 0-3.484 1.031-4.967 2.122C21.199 26.471 19.12 28 15 28c-7.776 0-13-2.813-13-7 0-3.434 3.168-6 6-6h1v-1c0-3.668 3.588-5 6-5h.82l.161-.804c.318-1.588 1.021-2.16 1.835-2.822.866-.705 1.83-1.489 2.106-3.286M19 1c0 4.062-3.188 2.938-4 7-3.313 0-7 1.977-7 6-3.34 0-7 3.009-7 7 0 4.653 5.364 8 14 8 7.71 0 8.854-5 13-5 3.205 0 5 2.442 5 4 0 0 6-3.256 6-9 0-4.535-4.75-11-12-11 0-4.438-5.063-7-8-7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c74343",
    strokeMiterlimit: 10,
    d: "M8.5 14.5c0 3.842 4.812 6 10.5 6"
  })));
};
export default SvgHabitsSweets;